export enum PagesTypes {
  CUSTOM_PAGE = 1,
  CLICKS_MONITORING = 2,
  EXPORT_REPORT = 3,
}
